import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import {
  ImageButton,
  ImageButtonConteinerProtocol,
  ImageSize
} from '../../../assets/styles/image_style';
import { functionsUseFul } from 'views/Protocol/list/assets/functionsUseFul';
import { dateRules } from 'views/Protocol/form/assets/functions';
import { ErrorFormMessage } from 'components/ErrorFormMessage';
import SimpleHeader from 'components/Headers/SimpleHeader';
import { ErrorMessage } from '@hookform/error-message';
import { Controller, useForm } from 'react-hook-form';
import DatePicker from 'components/Inputs/DatePicker';
import React, { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { individual_column_style } from 'assets/styles/table_custom_style';
import Pagination from 'components/Pagination';
import Loader from 'react-loader-spinner';
import SchedulingService from './service';
import Select from 'react-select/async';
import csvImage from '../../../assets/img/csv.png';
import xlsxImage from '../../../assets/img/xlsx.png';
import { Tooltip } from '@material-ui/core';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Form
} from 'reactstrap';
import FlexSelect from 'components/Inputs/FlexSelect';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import UserService from '../../User/service';
import { toast } from 'react-toastify';
import {
  useMemorizeFilters,
  POSSIBLE_FILTERS_ENTITIES
} from 'hooks/useMemorizeInputsFilters';
import { saveAs } from 'file-saver';
import { ClearFiltersButton } from 'components/ClearFiltersButton';
import { individual_header_style } from 'assets/styles/table_custom_style';
import { custom_select } from 'assets/styles/multiple_select';
import { useSearchAccounts } from 'views/CRM/Account/hooks/useSearchAccounts';
import { ItemPerPageSelect } from 'components/Inputs/ItemPerPageSelect';

export const SchedulingReport = () => {
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [account, setAccount] = useState();
  const { getDateBegin } = functionsUseFul();
  const [quantity, setQuantity] = useState(0);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [loadingXLSX, setloadingXLSX] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [dataToSend, setDataToSend] = useState(null);
  const { isSearching, filterAccounts } = useSearchAccounts();
  const { getMemorizedFilters, memorizeFilters, clearMemorizedFilters } =
    useMemorizeFilters(POSSIBLE_FILTERS_ENTITIES.REPORT_WORK_SCHEDULE_ANALYTIC);
  const [minAbsencePercentage, setMinAbsencePercentage] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const toISOFormat = useCallback((dateTimeString, bar = false) => {
    const [date] = dateTimeString.split(' ');
    const [DD, MM, YYYY] = date.split('/');
    if (bar) return `${YYYY}/${MM}/${DD}`;
    return `${YYYY}-${MM}-${DD}`;
  }, []);

  const getReports = (dataToSend, page) => {
    setIsLoading(true);
    SchedulingService.getSchedulingAnalytics({
      limit: itemsPerPage,
      page,
      ...dataToSend
    })
      .then((res) => {
        if (res.data.totalRegisters === 0) {
          toast.info('Nenhum registro encontrado');
        }
        let filteredData = res.data.data;

        if (minAbsencePercentage !== null) {
          filteredData = filteredData.filter(
            (item) => item.absenceTotalPercentage >= minAbsencePercentage
          );
        }

        setQuantity(res.data.totalRegisters);
        setData(filteredData);
      })
      .catch((err) => {
        console.log('err', err);
        toast.error(
          err || 'Ocorreu um erro por favor entre em contato com o suporte'
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onSubmit = (data, isNotFromUseEffect = true) => {
    try {
      let pageSavedOnMemory = 1;
      if (!isNotFromUseEffect) {
        pageSavedOnMemory = getMemorizedFilters()?.page ?? 1;
      }
      memorizeFilters({
        ...data,
        page: pageSavedOnMemory,
        minAbsencePercentage
      });
      const formatedData = formatData(data);
      setDataToSend(formatedData);
      setIsLoading(true);
      setActivePage(pageSavedOnMemory);
      getReports(formatedData, 1);
    } catch (err) {
      toast.error(err || 'Ops, ocorreu um erro!', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
    return;
  };

  const formatData = (data) => {
    data.dateBegin = new Date(toISOFormat(data.dateBegin)).toISOString();
    data.dateEnd = new Date(toISOFormat(data.dateEnd)).toISOString();
    data.entityType = data.entityType === '' ? [] : data.entityType;
    return data;
  };

  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const { control, handleSubmit, getValues, setValue, errors } = useForm({
    defaultValues: {
      dateBegin: getMemorizedFilters()?.dateBegin ?? getDateBegin(),
      dateEnd:
        getMemorizedFilters()?.dateEnd ??
        new Date().toLocaleDateString('pt-br'),
      responsibleLogin: getMemorizedFilters()?.responsibleLogin ?? '',
      entityType: getMemorizedFilters()?.entityType ?? ''
    }
  });

  const handlePageChange = (page) => {
    setActivePage(page);
    const prevFilters = getMemorizedFilters();
    memorizeFilters({ ...prevFilters, page });
    getReports(dataToSend, page);
  };

  const handleReportExport = (typeExport, e) => {
    e.preventDefault();
    if (typeExport == 'XLSX') {
      setloadingXLSX(true);
      SchedulingService.getSchedulingAnalyticsXlsx({
        ...dataToSend
      })
        .then((res) => {
          if (res.data.size === 0) {
            setloadingXLSX(false);
            toast.info('Nenhum registro foi encontrado!');
          } else {
            const url = window.URL.createObjectURL(
              new Blob([res.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'
              })
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'relatorio-de-agendamento.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();

            setloadingXLSX(false);
          }
        })
        .catch(() => {
          setloadingXLSX(false);
          toast.info('Nenhum registro foi encontrado!');
        });
    } else if (typeExport == 'CSV') {
      setLoadingCSV(true);
      SchedulingService.getSchedulingAnalyticsCsv({
        ...dataToSend
      })
        .then((res) => {
          if (res.data.size === 0) {
            setLoadingCSV(false);
            toast.info('Nenhum registro foi encontrado!');
          } else {
            saveAs(
              new Blob([res.data], { type: res.headers['content-type'] }),
              `relatorio-de-agendamento-${new Date()}.csv`
            );

            setLoadingCSV(false);
          }
        })
        .catch(() => {
          setLoadingCSV(false);
          toast.info('Nenhum registro foi encontrado!');
        });
    }
  };

  const handleReset = () => {
    const defaultFieldValues = {
      dateBegin: getDateBegin(),
      dateEnd: new Date().toLocaleDateString('pt-br'),
      responsibleLogin: '',
      disable: '',
      entityType: ''
    };

    for (const key in defaultFieldValues) {
      setValue(`${key}`, defaultFieldValues[key]);
    }

    clearMemorizedFilters();
    setMinAbsencePercentage(null);
  };

  useEffect(() => {
    UserService.getAll(false, undefined, undefined, false)
      .then((response) => {
        setUsers(response.data.data);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, []);

  useEffect(() => {
    if (users.length > 0) {
      const formValues = getValues();
      onSubmit(formValues, false);
    }
  }, [users]);

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        showBackArrow="not"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <div className="d-flex flex-row justify-content-between">
                    <h3 className="mb-0">Relatório de Agendamento</h3>
                  </div>
                </CardHeader>
                <CardBody className="pt-2">
                  <Form
                    className="needs-validation"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <ClearFiltersButton handleOnClick={handleReset} />
                    <Row className="mb-3">
                      <Col md={{ size: 4 }}>
                        <label className="form-control-label">
                          Data inicial*
                        </label>
                        <Controller
                          render={(props) => (
                            <DatePicker
                              fieldName="dateBegin"
                              valueController={(fieldName, value) => {
                                setValue(fieldName, value);
                              }}
                              defaultValue={props.value}
                            />
                          )}
                          control={control}
                          name="dateBegin"
                          defaultValue={
                            getMemorizedFilters()?.dateBegin ?? getDateBegin()
                          }
                        />
                        <ErrorMessage
                          errors={errors}
                          name="dateBegin"
                          render={({ message }) => (
                            <ErrorFormMessage message={message} />
                          )}
                        />
                      </Col>
                      <Col md={{ size: 4 }}>
                        <label className="form-control-label">
                          Data final*
                        </label>
                        <Controller
                          render={(props) => (
                            <DatePicker
                              fieldName="dateEnd"
                              valueController={(fieldName, value) => {
                                setValue(fieldName, value);
                              }}
                              defaultValue={props.value}
                            />
                          )}
                          control={control}
                          name="dateEnd"
                          defaultValue={
                            getMemorizedFilters()?.dateEnd ??
                            new Date().toLocaleDateString('pt-br')
                          }
                          rules={{
                            ...dateRules,
                            validate: async (value) => {
                              if (
                                new Date(await toISOFormat(value, true)) <
                                new Date(
                                  await toISOFormat(
                                    getValues()['dateBegin'],
                                    true
                                  )
                                )
                              ) {
                                return 'A data final não pode ser anterior à inicial!';
                              } else {
                                return true;
                              }
                            }
                          }}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="dateEnd"
                          render={({ message }) => (
                            <ErrorFormMessage message={message} />
                          )}
                        />
                      </Col>
                      <Col md={{ size: 4 }}>
                        <label className="form-control-label">Conta</label>
                        <Controller
                          render={(props) => (
                            <Select
                              styles={custom_select}
                              placeholder="Busca rápida"
                              isClearable={true}
                              name="accountId"
                              fieldName="accountId"
                              valueController={setValue}
                              isLoading={isSearching}
                              loadingMessage={() => 'Buscando...'}
                              noOptionsMessage={({ inputValue }) =>
                                !inputValue
                                  ? 'Digite para pesquisar'
                                  : 'Nenhum resultado encontrado'
                              }
                              loadOptions={async (inputValue) => {
                                const res = await filterAccounts(inputValue);
                                return (
                                  res &&
                                  res.map((account) => ({
                                    label: account.name,
                                    value: account.id
                                  }))
                                );
                              }}
                              onChange={(data) => {
                                if (data) {
                                  const { value, label } = data;
                                  setAccount({
                                    label,
                                    value
                                  });
                                  setValue('accountId', value);
                                  memorizeFilters({
                                    ...getMemorizedFilters(),
                                    accountId: value,
                                    accountName: label
                                  });
                                } else {
                                  setAccount(null);
                                  setValue('accountId', null);
                                }
                              }}
                              value={
                                account
                                  ? {
                                      label: account.label,
                                      value: account.id
                                    }
                                  : ''
                              }
                              defaultValue={
                                account
                                  ? {
                                      label: account.label,
                                      value: account.id
                                    }
                                  : ''
                              }
                            />
                          )}
                          control={control}
                          name="accountId"
                          defaultValue=""
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <label className="form-control-label">
                          Responsável
                        </label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={users}
                              isMulti={true}
                              value={props.value}
                              valueController={setValue}
                              closeMenuOnSelect={false}
                              fieldName="responsibleLogin"
                              labelName="name"
                              valueName="login"
                            />
                          )}
                          control={control}
                          name="responsibleLogin"
                          defaultValue={
                            getMemorizedFilters()?.responsibleLogin ?? ''
                          }
                        />
                      </Col>
                      <Col md="6">
                        <label className="form-control-label">
                          Tipo de Entidade
                        </label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={[
                                { value: 'LEAD', label: 'Lead' },
                                { value: 'OPPORTUNITY', label: 'Oportunidade' },
                                { value: 'PROTOCOL', label: 'Protocolo' }
                              ]}
                              isMulti={true}
                              value={props.value}
                              valueController={setValue}
                              closeMenuOnSelect={false}
                              fieldName="entityType"
                              labelName="label"
                              valueName="value"
                            />
                          )}
                          control={control}
                          name="entityType"
                          defaultValue={
                            getMemorizedFilters()?.responsibleLogin ?? ''
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div
                          className="mt-3"
                          style={{
                            display: 'flex',
                            maxHeight: '46px',
                            height: '46px'
                          }}
                        >
                          <Button
                            style={buttonStyle(
                              systemConfiguration.primary_color
                            )}
                            type="submit"
                          >
                            Filtrar
                          </Button>
                          <Col md="3">
                            <ItemPerPageSelect
                              valueController={setItemsPerPage}
                            />
                          </Col>
                        </div>
                      </Col>
                      <Col
                        md="6"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                          float: 'right'
                        }}
                      >
                        <button
                          id="button_xlsx"
                          style={ImageButton}
                          onClick={(e) => {
                            handleReportExport('XLSX', e);
                          }}
                          disabled={data?.length && !loadingXLSX ? false : true}
                        >
                          <Tooltip
                            title={
                              <p style={{ fontSize: '14px' }}>
                                {data?.length
                                  ? 'Fazer download do relatório de agendamentos.'
                                  : 'Nenhum registro para realizar download, faça um filtra para realizar está ação'}
                              </p>
                            }
                            arrow
                          >
                            {loadingXLSX ? (
                              <Loader
                                type="ThreeDots"
                                visible={true}
                                height="40"
                                width="40"
                              />
                            ) : (
                              <img
                                src={xlsxImage}
                                alt="xlsx"
                                style={ImageSize}
                              />
                            )}
                          </Tooltip>
                        </button>
                        <button
                          style={ImageButton}
                          name="csv"
                          onClick={(e) => {
                            handleReportExport('CSV', e);
                          }}
                          disabled={data?.length && !loadingCSV ? false : true}
                        >
                          <Tooltip
                            title={
                              <p style={{ fontSize: '14px' }}>
                                {data?.length
                                  ? 'Fazer download do relatório de agendamentos.'
                                  : 'Nenhum registro para realizar download, faça um filtra para realizar está ação'}
                              </p>
                            }
                            arrow
                          >
                            {loadingCSV ? (
                              <Loader
                                type="ThreeDots"
                                visible={true}
                                height="40"
                                width="40"
                              />
                            ) : (
                              <img src={csvImage} alt="pdf" style={ImageSize} />
                            )}
                          </Tooltip>
                        </button>
                      </Col>
                    </Row>
                    <div>
                      <div style={{ fontSize: 'small', float: 'right' }}>
                        {quantity} resultado(s) encontrado(s)
                      </div>
                    </div>
                  </Form>
                </CardBody>
                {data && data.length > 0 ? (
                  isLoading ? (
                    <Row className="justify-content-md-center">
                      <Loader
                        type="TailSpin"
                        color={systemConfiguration.primary_color}
                        height={100}
                        width={100}
                      />
                    </Row>
                  ) : (
                    <>
                      <ToolkitProvider
                        data={data}
                        keyField="id"
                        columns={[
                          {
                            dataField: 'description',
                            text: 'Descrição',
                            sort: true,
                            style: individual_column_style
                          },
                          {
                            dataField: 'responsible',
                            text: 'Responsável',
                            sort: true,
                            style: individual_column_style
                          },
                          {
                            dataField: 'scheduleDate',
                            text: 'Data do Agendamento',
                            sort: true,
                            style: individual_column_style,
                            headerStyle: individual_header_style,
                            formatter: (rowContent) => {
                              const data = new Date(rowContent);
                              return `${data.toLocaleDateString(
                                'pt-br'
                              )} - ${data.toLocaleTimeString('pt-br')}`;
                            }
                          },
                          {
                            dataField: 'entity',
                            text: 'Entidade',
                            sort: true,
                            style: individual_column_style
                          },
                          {
                            dataField: 'title',
                            text: 'Titulo',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.title || '-';
                            }
                          },
                          {
                            dataField: 'account',
                            text: 'Conta',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.account?.name || '-';
                            }
                          },
                          {
                            dataField: 'contact',
                            text: 'Contato',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.contact?.name || '-';
                            }
                          }
                        ]}
                      >
                        {(props) => (
                          <div style={{ overflow: 'auto' }}>
                            <BootstrapTable
                              {...props.baseProps}
                              bootstrap4={true}
                              bordered={false}
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                      <Pagination
                        activePage={activePage}
                        itemsCountPerPage={itemsPerPage}
                        totalItemsCount={quantity}
                        onChange={handlePageChange.bind(this)}
                      />
                    </>
                  )
                ) : null}
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};
